import "./App.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./components/home/Home";

import About from "./components/About/About";
import Contact from "./components/ContactUs/Contact";
import ViewProduct from "./components/pages/ViewProduct";
import Product from "./components/pages/Product";

function App() {
	return (
		<Router>
			<Routes>
				<Route path="/" element={<Home />} />
				<Route path="/about" element={<About />} />
				<Route path="/contact" element={<Contact />} />
				<Route path="/:category/:year" element={<Product />} />
				<Route path="/product/id/:style" element={<ViewProduct />} />
			</Routes>
		</Router>
	);
}

export default App;
